import React from 'react';
import classnames from 'classnames';

import { abbrNum } from 'utils/helper/common';

import './notification-badge.scss';

type Props = {
  value: number,
  size: 'smaller' | 'small' | 'normal',
  location: 'nav' | 'normal',
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void
};

const NotificationBadge = ({ value, size, location, onClick }: Props) => {
  if (value <= 0) {
    return null;
  }

  const longValue = value && String(value).length > 2;
  const badgeProps: React.HTMLAttributes<HTMLSpanElement> = {
    className: classnames({
      notification__badge: true,
      [`notification__badge--location-${location}`]: location,
      [`notification__badge--size-${size}`]: size,
      [`notification__badge--long-value-${longValue}`]: longValue
    })
  };

  if (onClick) {
    badgeProps.onClick = onClick;
  }

  return (
    <span {...badgeProps}>
      {abbrNum(value, { decimal: 1 })}
    </span>
  );
};

NotificationBadge.defaultProps = {
  size: 'normal',
  location: 'normal'
};

export default NotificationBadge;
